module.exports = __webpack_public_path__ + "img/imiwin-support.411bb034.png";